const RoleCrudModalLangKey = [
	'title_create',
	'title_edit',
	'title_clone',
	'title_remove_single',
	'title_remove_multiple',
	'title_remove_multiple_cnt',
	'title_not_remove_multiple_cnt',
	'field_code_label',
	'field_code_placeholder',
	'field_name_label',
	'field_name_placeholder',
	'field_is_system_label',
	'field_is_buyer_label',
	'field_in_group_label',
	'field_in_group_placeholder',
	'field_is_team_label',
	'field_is_team_placeholder',
	'field_team_report_label',
	'field_team_report_placeholder',
	'field_notes_label',
	'field_notes_placeholder',
	'msg_remove_confirm',
	'btn_create',
	'btn_update',
	'btn_clone',
	'btn_remove',
	'btn_close'
] as const

type IRoleCrudModalLangKey = typeof RoleCrudModalLangKey[number]

export type IRoleCrudModalLang = {
	role_crud_modal: Record<IRoleCrudModalLangKey, string>
}

const langEntries = RoleCrudModalLangKey.map(
	(key: IRoleCrudModalLangKey) => [key, `role_crud_modal.${key}`]
)

const langObj: Record<IRoleCrudModalLangKey, string> = Object.fromEntries(langEntries)

export const ROLE_CRUD_MODAL_LANG_KEY: IRoleCrudModalLang = {
	role_crud_modal: langObj
}